import React, { useState } from 'react';
import { Button, Card, Col, Divider, Input, notification, Row } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { connect, useDispatch, useSelector } from 'react-redux';
import { Form } from '@ant-design/compatible';

import { saveSecurityDetailsAction } from '../../../actions/UserActions';
import '@ant-design/compatible/assets/index.css';

const Security = ({ form }) => {
  const dispatch = useDispatch();

  const [confirmDirty, setConfirmDirty] = useState(false);

  const { currentUser } = useSelector(store => ({
    currentUser: store.userReducer.currentUser,
  }));

  const handleConfirmBlur = e => {
    const { value } = e.target;
    setConfirmDirty(confirmDirty || !!value);
  };

  const compareToFirstPassword = (rule, value, callback) => {
    if (value && value !== form.getFieldValue('newPassword')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  };

  const validateToNextPassword = (rule, value, callback) => {
    if (value && confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  const handleSubmit = e => {
    e.preventDefault();
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        
        dispatch(saveSecurityDetailsAction(values, currentUser.id));
        notification.success({
          message: 'Success',
          description: 'User details are successfully updated!',
        });
      }
    });
  };

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  const { getFieldDecorator } = form;

  return (
    <Card bordered={false}>
      <Row>
        <Col span={16} offset={2}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Form {...formItemLayout} onSubmit={handleSubmit}>
            <Form.Item label="Username">
              {getFieldDecorator('username', {
                initialValue:
                  currentUser && currentUser.username
                    ? currentUser.username
                    : undefined,
                rules: [],
              })(<Input />)}
            </Form.Item>
            <Form.Item label="Current Password" hasFeedback>
              {getFieldDecorator('currentPassword', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your current password!',
                  },
                ],
              })(<Input.Password />)}
            </Form.Item>
            <Form.Item label="New Password" hasFeedback>
              {getFieldDecorator('newPassword', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your password!',
                  },
                  {
                    validator: validateToNextPassword,
                  },
                ],
              })(<Input.Password />)}
            </Form.Item>
            <Form.Item label="Confirm Password" hasFeedback>
              {getFieldDecorator('confirm', {
                rules: [
                  {
                    required: true,
                    message: 'Please confirm your password!',
                  },
                  {
                    validator: compareToFirstPassword,
                  },
                ],
              })(<Input.Password onBlur={handleConfirmBlur} />)}
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <Divider />
      <Row type="flex" justify="center">
        <Button type="primary" onClick={handleSubmit}>
          <CheckOutlined /> Save
        </Button>
      </Row>
    </Card>
  );
};
const WrappedSecurity = Form.create({ name: 'securityForm' })(Security);

Security.propTypes = {
  form: PropTypes.object,
  currentUser: PropTypes.object,
  saveSecurityDetailsAction: PropTypes.func,
};

function mapStateToProps() {
  return {};
}
export default connect(mapStateToProps, {
  saveSecurityDetailsAction,
})(WrappedSecurity);
